import React from 'react';
import './Team.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/about/team/1.png';

const Team = () => {

    const teams = [
        {
            'img': imgOne,
            'name': 'Dr. Vinamrata',
            'designation': 'MDS Specialist',
            'qualification': 'Govt. Dental College, Ahmedabad',
            'specialization': 'Periodontology & Implantology'
        }
    ]


    return (
        <section id="expert" className='team-section pt-100'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <SectionTitle 
                            subTitle="Meet Our Expert"
                            title="Dr. Vinamrata - MDS Specialist"
                        />
                    </div>

                    <div className="col-lg-5">
                        <p className='pt-5'>Dr. Vinamrata is a highly qualified MDS specialist from Govt. Dental College, Ahmedabad, specializing in Periodontology & Implantology. With extensive experience and advanced training, she provides exceptional dental care to patients in Yamunanagar.</p>
                    </div>
                </div>

                <div className="row justify-content-center">
                    {
                        teams.map (team => 
                            <div className="col-lg-6 col-md-8">
                                <div className="team-card">
                                    <div className="team-img">
                                        <img src={team.img} alt="Dr. Vinamrata" />
                                    </div>
                                    <div className="team-info">
                                        <h3>{team.name}</h3>
                                        <h4>{team.designation}</h4>
                                        <p className="qualification">{team.qualification}</p>
                                        <p className="specialization">{team.specialization}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Team;